/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const developerRemoteLookupSchema = z.any();

export const developerRemoteLookupIdSchema = common.objectId;

export const developerRemoteLookupItemSchema = z.object({
  id: common.objectId,
  email: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  image_url: z.string().nullable(),
  last_signed_in_at: z.int().nullable(),
  internal_role: z
    .enum([
      "account_manager",
      "account_manager_admin",
      "admin",
      "alliance",
      "alliance_admin",
      "audit_admin",
      "business_intelligence",
      "devops",
      "devops_admin",
      "engineering",
      "engineering_admin",
      "engineering_with_oncall",
      "growth",
      "growth_admin",
      "growth_engineer",
      "integration",
      "integration_admin",
      "marketing",
      "marketing_admin",
      "partner",
      "partner_admin",
      "product",
      "product_admin",
      "provisioning_ops",
      "provisioning_ops_admin",
      "revenue_ops",
      "revenue_ops_admin",
      "robot",
      "sales",
      "sales_admin",
      "segments_export",
      "smsops",
      "smsops_admin",
      "solcon",
      "solcon_admin",
      "solcon_eu",
      "success",
      "success_admin",
      "success_eu",
      "success_impersonation_account",
      "success_read_only_impersonation_account",
      "support",
      "support_admin",
      "support_engineer",
      "support_eu",
      "support_sme",
      "technical_account_manager",
      "technical_account_manager_admin",
    ])
    .nullable(),
  is_company_admin: z.boolean(),
  is_impersonation_user: z.boolean(),
  is_suspended: z.boolean(),
});

export const developerRemoteLookupFiltersSchema = z.object({
  include_impersonation_users: z.boolean().nullable().optional(),
});

export const developerRemoteLookupValidators = {
  id: developerRemoteLookupIdSchema,
  item: developerRemoteLookupItemSchema,
  filters: developerRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 227adcb49e3db4d1058b180dce34921d */
